import { action } from 'easy-peasy';
import { IActionAllocationClientsByGroup } from '../types';

const setAllocationClientsByGroup: IActionAllocationClientsByGroup = action((state, payload) => {
  state.locationGroups = payload;
});

export default setAllocationClientsByGroup;
